import store from '~/store'

export default async (to, from, next) => {
  // Get the authenticated user
  const user = store.getters['auth/user']

  // If no user, continue normally (auth middleware will handle it)
  if (!user) {
    return next()
  }

  // Check if user needs to reset password
  if ((user.is_password_reset === false || user.is_password_reset === 0) && !user.impersonated_by) {
    // If user is already on update-password page, allow access
    if (to.name === 'update-password') {
      return next()
    }
    // For any other page (including login), redirect to update-password
    // This prevents them from accessing any other page until password is reset
    return next({ name: 'update-password' })
  }

  // If password has been reset, allow normal navigation
  next()
}
